
import { startGame } from './startGame';
import { makeDecision } from './makeDecision';
import { advanceYear } from './advanceYear';
import { updateKpi } from './updateKpi';
import { addSkill } from './addSkill';
import { completeChallenge } from './completeChallenge';
import { setCurrentChallenge } from './setCurrentChallenge';
import { setCurrentSpecialEvent } from './setCurrentSpecialEvent';
import { completeSpecialEvent } from './completeSpecialEvent';
import { setHasTutorialCompleted } from './setHasTutorialCompleted';
import { levelUp } from './levelUp';
import { selectCareerPath } from './selectCareerPath';
import { setSimulationComplete } from './setSimulationComplete';
import { checkSimulationComplete, shouldLevelUp } from './helpers';
import { updateSettings } from './updateSettings';

// Export all game actions as a single object
export const gameActions = {
  startGame,
  makeDecision,
  advanceYear,
  updateKpi,
  addSkill,
  completeChallenge,
  setCurrentChallenge,
  setCurrentSpecialEvent,
  completeSpecialEvent,
  setHasTutorialCompleted,
  levelUp,
  selectCareerPath,
  setSimulationComplete,
  updateSettings
};

// Export helpers separately
export { checkSimulationComplete, shouldLevelUp };
